import React from "react";
import { DetailsSection } from "components/DetailsSection";
import { MapToLine } from "helpers/Helpers";
import { KeyIcon } from "components/icons/Icons";
import { AdditionalServiceType } from "generated/types/types";
import { useTranslation } from "react-i18next";

type Props = {
    additionalServiceType: AdditionalServiceType;
    collectionAddressLines: string[] | null;
    additionalNotes: string | null;
};

/**
 * A component displaying the additional services that the user has requested.
 */
export const AdditionalServicesSection: React.FC<Props> = props => {
    const { t } = useTranslation();
    const additionalServiceType = props.additionalServiceType;
    const messageText = getMessageText(additionalServiceType, t);
    
    const collectionAddressLines: string[] = props.collectionAddressLines ?? [];
    const lines =
    additionalServiceType === AdditionalServiceType.Delivery
        ? [messageText, ...collectionAddressLines.filter(l => !!l && l.trim().length > 0)]
        : [messageText];

    const additionalNotes = props.additionalNotes
        ? t("service_center_search_note", { note: props.additionalNotes })
        : null;

     if (additionalNotes) lines.push(additionalNotes);

    return (
        <DetailsSection
            iconComponent={KeyIcon}
            heading={t("service_center_additional_info")}
            lines={MapToLine(lines)}
        />
    );
};

const getMessageText = (additionalServiceType: AdditionalServiceType, t: (key: string) => string): string => {
    switch (additionalServiceType) {
        case AdditionalServiceType.NoAdditional:
            return t("service_center_additional_no_additional")
        case AdditionalServiceType.Courtesy:
            return t("service_center_additional_courtesy")
        case AdditionalServiceType.Delivery:
            return t("service_center_additional_delivery")
        case AdditionalServiceType.WhileUWait:
            return t("service_center_additional_while_u_wait")
        }
};
